import { CommonModule, DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild, forwardRef, Inject } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  Validators,
} from '@angular/forms';

import {
  NgbDropdownModule,
  NgbDatepickerModule,
  NgbTimepickerModule,
  NgbDate,
  NgbTimeStruct,
} from '@ng-bootstrap/ng-bootstrap';
import { DateParserFormatter } from '../../utils/helper/date-parser-formatter';

@Component({
  selector: 'date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatePickerComponent),
      multi: true,
    },
  ],
  standalone: true,
  imports: [
    CommonModule,
    NgbDropdownModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    FormsModule,
  ],
})
export class DatePickerComponent implements OnInit, ControlValueAccessor {
  @Input() minDate: NgbDate;
  @Input() maxDate: NgbDate;
  @Input() lotOrHipText: string;
  disabled = false;
  selectedDate: NgbDate;

  selectDate(model: NgbDate) {
    if (!model) { return; }
    this.selectedDate = model;

  }

  private onChangeCallback: (_: any) => void = () => { };
  private onTouchedCallback: () => void = () => { };

  constructor(@Inject(DateParserFormatter) private dateParserFormatter: DateParserFormatter) { 
   
  }

  ngOnInit(): void {

    this.dateParserFormatter.setIsUSTimeZone(this.lotOrHipText);
  }
  public getDateFormat(): string {
    return this.dateParserFormatter.getDateFormat();
  }
  writeValue(value: Date): void {
    this.selectedDate = new NgbDate(
      new Date(value).getFullYear(),
      new Date(value).getMonth() + 1,
      new Date(value).getDate()
    );
    //console.log(value)
    this.updateValue();
  }
  onDateSelection(date: NgbDate) {
   
    this.selectedDate = date;
    this.updateValue();
  }
  private updateValue() {
   
    var formatedDate = this.dateParserFormatter.getDateForModel(this.selectedDate);
    this.onChangeCallback(formatedDate);
  }
  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
